import { render } from "./InputStd.vue?vue&type=template&id=bfafac7c"
import script from "./InputStd.vue?vue&type=script&lang=js"
export * from "./InputStd.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__